import IconCaretSelect from './component.jsx'
export default IconCaretSelect



// WEBPACK FOOTER //
// ./src/components/IconCaretSelect/index.js